var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.appLogin === false)?_c('PageIntro',{attrs:{"heading":'CREATE A FREE DIGITAL ACCOUNT',"body":''}}):_vm._e(),_c('Registration'),(_vm.appLogin === false)?_c('FooterShout',{attrs:{"type":'signin'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }